import { render, staticRenderFns } from "./SuitesMenu.vue?vue&type=template&id=5ec9bf46&lang=pug&"
import script from "./SuitesMenu.vue?vue&type=script&lang=js&"
export * from "./SuitesMenu.vue?vue&type=script&lang=js&"
import style0 from "./SuitesMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports